import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { useQuery, useQueryClient } from "react-query";
import useLocalStorage from "react-use-localstorage";
import { FormattedMessage } from "react-intl";
import { useParams } from "react-router-dom";

import Schedule from "./schedule";
import { PreLoader } from "../components/preloader";

import { ScheduleEndpointResponseObject } from "../types/presentation";
import UserContext from "../contexts/user";
import Logger from "../helpers/loggerConfig"

const MySchedule: React.FC<{
  locale: string;
  setLocale: any;
}> = ({ locale, setLocale }) => {
  //   const { event_slug, presentation_slug } = useParams<{
  //     event_slug: string;
  //     presentation_slug: string;
  //   }>();

  const event_slug = document.location.pathname.split("/")[1] || "invalid";
  // const presentation_slug =
   console.log("event_slug in my-schedule", event_slug);
  // const intl = useIntl();
  const queryClient = useQueryClient();
  const userContext = useContext(UserContext);
  const [fetchData, setFetchData] = useState(false);
  // const slug = new URLSearchParams(document.location.search).get('event') || "invalid";
  const [eventPassword] = useLocalStorage(event_slug, "");

  const { data, isLoading, error } = useQuery(
    "event",
    async () => {
      const url = process.env.REACT_APP_API_ENDPOINT + "/ /schedule/";
      // +
      // event_slug;
       console.log(
        "url in my schedule",
        `${process.env.REACT_APP_API_ENDPOINT}/api/public/schedule/${event_slug}`
      );

      const response = await axios.get<ScheduleEndpointResponseObject>(
        `${process.env.REACT_APP_API_ENDPOINT}/api/public/schedule/${event_slug}`,

        {
          params: { password: eventPassword },
        }
      );
      return response.data;
    },
    {
      enabled: fetchData,
      onSuccess: (resp) => {
        const { event } = resp.data;
        resp.data.presentations.forEach((presentation) => {
          queryClient.setQueryData(["presentation", presentation._id], () => ({
            statusCode: 201,
            message: "event.fetch-success",
            data: { event, presentation },
          }));
        });
      },
    }
  );

  useEffect(() => {
    //  console.log('debug: ', data, presentation_id);
    if (!data) {
      Logger(" console.log('debug: ', data, presentation_id)")
  
      setFetchData(true);
    }
  }, [setFetchData, data]);

   console.log("isLoading", isLoading);
  // if (isLoading) return <i>home.tsx: isLoading</i>
  //   if (isLoading) return <PreLoader />
  // { console.log("data,error",data,error)}
  if (error || !data) return <div></div>;

  // <div className="login-landing">
  //   <div className="login-container">
  //     <div className="login">
  //       <h4>
  //         <FormattedMessage id="error.retry.message" />
  //       </h4>
  //     </div>
  //   </div>
  // </div>;

  const { data: eventData } = data;

  return (
    <div className="home-container-with-login my-presentation-container">
      {/* { console.log(
        "in my presentation page -----------------------------------------------------------------------------------------------",
        eventData
      )} */}

      {/*  isSpeaker should be true for showing the video upload option and my presentation  */}
      <Schedule
        locale={locale}
        setLocale={setLocale}
        eventData={eventData}
        mySchedule={true}
        setSchedule={"my-schedule"}
        isSpeaker={false}
       // isSpeaker={userContext.user?.is_speaker}
      />
    </div>
  );
};

export default MySchedule;
